const COMPRESSIBLE = ["image/jpeg", "image/png", "image/webp"];

export const compressImage = (file, options = {}) => {
  const { maxWidth = 1600, maxHeight = 1600, quality = 0.75 } = options;

  return new Promise((resolve) => {
    // Never reject: fall back to the original file
    if (!COMPRESSIBLE.includes(file.type)) return resolve(file);

    const url = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      URL.revokeObjectURL(url);

      let { width, height } = img;
      const ratio = Math.min(maxWidth / width, maxHeight / height, 1);
      width = Math.round(width * ratio);
      height = Math.round(height * ratio);

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff"; // avoid black background for transparent PNGs
      ctx.fillRect(0, 0, width, height);
      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob(
        (blob) => {
          // keep the original if compression failed or didn't help
          if (!blob || blob.size >= file.size) return resolve(file);
          resolve(
            new File([blob], file.name.replace(/\.\w+$/, ".jpg"), {
              type: "image/jpeg",
              lastModified: Date.now(),
            })
          );
        },
        "image/jpeg",
        quality
      );
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(file);
    };

    img.src = url;
  });
};